import PartnerHeader from "./PartnerHeader";
export default PartnerHeader;
